import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import FeaturedSection from './components/FeaturedSection';
import RankingSection from './components/RankingSection';
import LatestSection from './components/LatestSection';
import { siteInfo } from '@/mocks/home';

export default function Home() {
  const schemaData = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Organization',
        name: siteInfo.name,
        url: 'https://meiguishipin.com',
        description: siteInfo.description,
        foundingDate: '2018',
      },
      {
        '@type': 'WebSite',
        name: siteInfo.name,
        url: 'https://meiguishipin.com',
        description: siteInfo.description,
        inLanguage: 'zh-CN',
        potentialAction: {
          '@type': 'SearchAction',
          'target': 'https://meiguishipin.com/search?q={search_term_string}',
          'query-input': 'required name=search_term_string',
        },
      },
      {
        '@type': 'WebPage',
        name: '玫瑰视频 - 首页',
        url: 'https://meiguishipin.com',
        description: '玫瑰视频聚合91视频、91视频网站、久久视频、91在线视频等热门资源，高清免费在线观看，电视剧全集和电影大全不缓冲播放。',
        isPartOf: { '@type': 'WebSite', name: siteInfo.name },
      },
    ],
  };

  return (
    <>
      <ScrollToTop />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaData) }}
      />
      <main>
        <Navbar />
        <HeroSection />
        <CategoryNav />
        <FeaturedSection />
        <RankingSection />
        <LatestSection />
      </main>
      <Footer />
    </>
  );
}